export default __webpack_public_path__ + "static/media/check.68ee953a.svg";